export const Breadcrumbs = {
  Fallback: {
    EMOJI: "🤷‍♂️",
    TITLE: "Невідома сторінка",
  },
  SEPARATOR: "/",
};
